import { ExtraPropertyEntityType } from '@tribeplatform/gql-client/types'
import { useHotkeysSettings } from '@tribeplatform/react-components/common'
import { DISABLE_HOTKEYS_KEY } from '@tribeplatform/react-components/common/constants'
import { Form } from '@tribeplatform/react-components/Form'
import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { Link } from '@tribeplatform/react-components/Link'
import { useUpsertExtraProperty } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

interface FormFields {
  enableHotkeys: boolean
}

export const OtherSettings = () => {
  const { $t } = useI18n()
  const { mutateAsync: upsertExtraProperty, isLoading: isUpserting } =
    useUpsertExtraProperty()

  const { disabled } = useHotkeysSettings()

  const onSubmit = async (data: FormFields) => {
    const { enableHotkeys } = data
    try {
      await upsertExtraProperty({
        input: {
          entityType: ExtraPropertyEntityType.Network,
          key: DISABLE_HOTKEYS_KEY,
          value: String(!enableHotkeys),
        },
      })

      toast({
        title: $t({
          defaultMessage: 'Successfuly updated settings',
          id: 'Admin.OtherSettings.Updated',
        }),
        status: 'success',
      })
    } catch (error) {
      toast({
        title: $t({
          defaultMessage: 'Failed to update settings',
          id: 'Admin.OtherSettings.FailedToUpdate',
        }),
        status: 'error',
      })
    }
  }

  return (
    <Card>
      <Card.Header
        title={$t({
          defaultMessage: 'Other settings',
          id: 'Admin.OtherSettings.Title',
        })}
      />
      <Card.Content>
        <Form<FormFields>
          defaultValues={{
            enableHotkeys: !disabled,
          }}
          onSubmit={onSubmit}
        >
          {({ formState: { isDirty } }) => (
            <div className="flex flex-col space-y-5">
              <Form.Toggle
                name="enableHotkeys"
                label={$t({
                  defaultMessage: 'Enable Keyboard Shortcuts',
                  id: 'Admin.OtherSettings.EnableKeyboardShortcuts',
                })}
                helperText={$t(
                  {
                    defaultMessage:
                      'When disabled, most keyboard shortcuts will be turned off, but text formatting shortcuts in the post editor and basic system shortcuts will still work. <link>Learn more</link>',
                    id: 'Admin.OtherSettings.EnableKeyboardShortcuts.HelperText',
                  },
                  {
                    link: chunks => (
                      <Link href="https://bettermode.com/hub/getting-started/post/keyboard-shortcuts-0e97HvUgMgqW5fA">
                        {chunks}
                      </Link>
                    ),
                  },
                )}
              />
              <Form.Actions>
                <Button type="submit" loading={isUpserting} disabled={!isDirty}>
                  <T defaultMessage="Update" id="Generics.Update" />
                </Button>
              </Form.Actions>
            </div>
          )}
        </Form>
      </Card.Content>
    </Card>
  )
}
